import axios from 'axios';
import config from './config';
import sso from './sso';
import { Message } from '@ss/mtd-vue';
import { get } from 'lodash';

let pending = [];

const cancelToken = axios.CancelToken;
const removePending = config => {
  for (let p in pending) {
    let item = p;
    let list = pending[p];
    if ((config.params && config.params.no_need_cancel) || (config.data && config.data.no_need_cancel)) {
      return false;
    }
    if (list.url === config.url + '&' + config.method) {
      // 当当前请求在数组中存在时执行函数体
      list.cancel(); // 执行取消操作
      pending.splice(item, 1); // 把这条记录从数组中移除
    }
  }
};

const service = axios.create(config);

// POST传参序列化(添加请求拦截器)
service.interceptors.request.use(
  config => {
    removePending(config);
    config.cancelToken = new cancelToken(c => {
      pending.push({ url: config.url + '&' + config.method, cancel: c });
    });
    const ssoid = sso.getSsoid();
    if (!ssoid) {
      sso.setCurrentURL();
      sso.redirectLogin();
    } else {
      config.headers['access-token'] = ssoid;
    }
    return config;
  },
  error => {
    Message({
      type: 'warning',
      message: '报错信息',
    });
    return Promise.reject(error);
  }
);

// 返回状态判断(添加响应拦截器)
service.interceptors.response.use(
  async res => {
    removePending(res.config);
    // 1.首先判断401用户认证失败问题
    const data = res.data;
    if (data && data.hasOwnProperty('status') && data.status === 401) {
      // window.location = data.data.url;
      await sso.logout();
      return Promise.reject(res);
    }
    // 2.检查数据
    if (data && data.code !== 0) {
      if (!res.config.hideErrorMessage) {
        Message({
          type: 'warning',
          message: `${data.message}`,
        });
      }
      return Promise.reject(res);
    } else if (res.status === 401) {
      await sso.logout();
    }
    return data;
  },
  async error => {
    if (!error.response) {
      return Promise.reject(error);
    }
    if (error.response.status === 401) {
      // 重定向到SSO登录页
      await sso.logout();
    } else if (error.response.status === 403) {
      Message({
        type: 'warning',
        message: '用户无权限访问数据，请联系管理员进行授权',
      });
    } else {
      Message({
        type: 'error',
        message: `${get(error, 'response.status', '未知原因')} 请求出错了哦 ~`,
      });
    }
    return Promise.reject(error);
  }
);

export default service;
